import type { FC } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { adsHistoryValidator } from '../validation';
import Box from '@mui/material/Box';
import FilterStatus from './FilterStatus';
import FilterDate from './FilterDate';
import AdsHistoryGrid from './AdsHistoryGrid';
import FilterSearch from './FilterSearch';
import type { z } from 'zod';
import { useListParams } from 'hooks';
import type { MarketingProcess } from 'types/shared';

type FormData = z.infer<typeof adsHistoryValidator.schema>;

interface AdsHistoryProps {
  marketingProcess?: MarketingProcess;
}

const AdsHistory: FC<AdsHistoryProps> = ({ marketingProcess }) => {
  const { q, status, date } = useListParams();
  const formMethod = useForm<FormData>({
    resolver: adsHistoryValidator.resolver,
    defaultValues: {
      q: q ?? '',
      status,
      packs: undefined,
      date,
      selectedAdsHistory: [],
    },
  });

  return (
    <FormProvider {...formMethod}>
      <Box
        sx={{ display: 'flex', width: '100%', height: '100%', flexDirection: 'column', gap: 2 }}
      >
        <Box
          sx={{ display: 'flex', width: '100%', flexDirection: 'row', gap: 2 }}
        >
          <Box sx={{ flex: 2 }}>
            <FilterSearch placeholder={'Search by creative or adset'} />
          </Box>
          <Box sx={{ flex: 1 }}>
            <FilterStatus />
          </Box>
          <Box sx={{ flex: 1 }}>
            <FilterDate />
          </Box>
        </Box>
        <Box sx={{
          display: 'flex',
          flex: 1,
          width: '100%',
          height: '100%',
          position: 'relative',
          flexDirection: 'column',
        }}>
          <Box sx={{
            position: 'absolute',
            width: '100%',
            height: '100%',
          }}>
            <AdsHistoryGrid marketingProcess={marketingProcess} />
          </Box>
        </Box>
      </Box>
    </FormProvider>
  );
};

export default AdsHistory;
